import { CrudMode, DataDisplay, Grid, ValidationErrors, pn, useElementBreakpoints } from "@compass/core";
import { Input } from "components";
import { SuppliesDetail, SuppliesDetailViewResource, ModelPropertyBase } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const SuppliesDetailPageBody = (props: {
  crudMode: CrudMode;
  suppliesDetail: SuppliesDetail;
  setSuppliesDetail: (value: SuppliesDetail) => void;
  viewResource: SuppliesDetailViewResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, fullFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<SuppliesDetail>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.suppliesDetail.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.suppliesDetail.name}
        onChange={(e) =>
          props.setSuppliesDetail(
            produce(props.suppliesDetail, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={fullFieldBreakpoints}>
        {nameField()}
      </Grid>
    </Grid>
  );
};
